import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Setting, TenantSettingName, TenantSettings } from '@navfleet/client/shared/models/settings';
import { environment } from '@navfleet/shared/core/environment';

const TENANT_SETTINGS_URL = `${environment.NAVFLEET_BACKEND}/api/v1/settings/tenant`;

@Injectable()
export class TenantSettingsApi {
    private readonly httpClient = inject(HttpClient);

    public getTenantSettings() {
        return this.httpClient.get<TenantSettings>(TENANT_SETTINGS_URL);
    }

    public updateTenantSetting(setting: Setting<TenantSettingName>) {
        return this.httpClient.post<void>(TENANT_SETTINGS_URL, [setting]);
    }
}
